module.exports = {"env":"local"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/redpost-env.json
// module id = +2Tr
// module chunks = 1